import styled, {css} from 'styled-components'

export const StyledContent = styled.main<{$gap: number; $columns: number; $margin: number}>(
    ({theme: {spacing}, $gap, $columns, $margin}) => css`
        display: flex;
        flex-direction: column;
        gap: ${spacing * $gap}px;
        width: 100%;
        & > div {
            display: grid;
            grid-template-columns: repeat(${$columns}, minmax(0, 1fr));
            gap: ${spacing * $gap}px;
            width: 100%;
            max-width: 100%;
            margin: ${spacing * $margin}px 0;
        }
    `
)

export const StyledTitle = styled.h1(
    ({theme: {typography}}) => css`
        ${typography.displayXs};
        font-weight: 500;
    `
)

export const StyledSectionTitle = styled.p(
    ({theme: {typography}}) => css`
        ${typography.textLg};
        font-weight: 500;
    `
)

export const StyledAnswerFieldTitle = styled.h3(
    ({theme: {typography, palette}}) => css`
        ${typography.textSm};
        font-weight: 500;
        color: ${palette.neutral[600]};
    `
)
export const StyledNoneValue = styled.p(
    ({theme: {palette}}) => css`
        color: ${palette.neutral[500]};
    `
)

export const StyledFieldContent = styled.ul(
    ({theme: {palette, spacing, typography}}) => css`
        width: 100%;
        & li {
            white-space: nowrap;
            text-overflow: ellipsis;
            overflow: hidden;
            width: 100%;
            &:before {
                content: '• ';
                margin-left: ${spacing * 1.5}px;
            }
            & li {
                margin-left: ${spacing * 2}px;
            }
        }

        & span {
            ${typography.textSm};
            color: ${palette.neutral[600]};
        }
    `
)
